module.exports = __webpack_public_path__ + "static/media/slider6.2df40336.png";